<shared-button
  class="flex justify-content-end mt-6 mx-5"
  mat-dialog-close
  [icon]="'clear'"
  [typeBtn]="'button'"
  [color]="'warn'"
  >Cerrar
</shared-button>
<shared-title class="flex justify-content-evenly">{{
  'Mapa del nivel : ' + this.data.name
}}</shared-title>
@if (isLoading) {
  <div
    class="d-flex justify-content-end align-items-center"
    style="margin-top: 200px; margin-left: 150px">
    <div
      class="flex flex-column lg:flex-row xl:flex-row align-items-center w-9 h-8rem justify-content-around">
      <div class="flex flex-column align-items-center justify-content-center">
        <br />
        <div>
          <h1 class="text-black text-lg md:text-xl lg:text-3xl xl:text-4xl">
            Cargando...
          </h1>
        </div>
      </div>
    </div>
  </div>
}

<pinch-zoom
  [double-tap]="false"
  [wheel]="false"
  [disableZoomControl]="'never'"
  [disablePan]="false"
  style="overflow: auto; background-color: rgba(255, 255, 255, 0.502)">
  <div style="overflow: auto">
    <canvas
      #canvas
      (dblclick)="canvasDblClickk($event)"
      (touchstart)="onTouchStart($event)"
      (touchend)="onTouchEnd($event)">
      >
    </canvas>
  </div>
</pinch-zoom>
